import React from 'react'
import FrontOfficeHero from './FrontOfficeHero'
import FrontOfficeContent from './FrontOfficeContent'
import FrontOfficeServices from './FrontOfficeServices'
import FrontOfficeTrustSection from './FrontOfficesection'
import FrontOfficeTransform from './FrontOfficeTransform'
import Footer from '../../Footer/Footer'









function FrontOfficeCorporate() {
    return (
        <div>
            <FrontOfficeHero/>
            <FrontOfficeContent/>
            <FrontOfficeServices/>
            <FrontOfficeTrustSection/>
            <FrontOfficeTransform/>
            <Footer/>
            
        </div>
    )
}

export default FrontOfficeCorporate
